import React, { useState, useEffect, useContext, createContext } from "react";
import { SignalRPubSub } from "./SignalRPubSub";

export const SignalRContext = createContext<SignalRPubSub>(undefined as any);

export const SignalRProvider: React.FunctionComponent<{ children: React.ReactNode }> = (props) => {
  const [signalRPubSubInstance, setSignalRPubSubInstance] = useState<SignalRPubSub>(undefined as any);

  useEffect(() => {
    if (!import.meta.env.VITE_AZURE_SIGNALR_CONNECTION_STRING) return;
    const signalRPubSub = new SignalRPubSub(import.meta.env.VITE_AZURE_SIGNALR_CONNECTION_STRING);
    signalRPubSub.start();
    setSignalRPubSubInstance(signalRPubSub);
  }, []);

  return <SignalRContext.Provider value={signalRPubSubInstance}>{props.children}</SignalRContext.Provider>;
};

export function useSignalR() {
  return useContext(SignalRContext);
}
